import { useHideCurrency } from '../store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '../store/slices/game/selectors';

export const useCurrencySymbol = (): string => {
  const hideCurrency = useHideCurrency();
  const currencyInfo = useGameStateSlice.getCurrencyInfo();
  return hideCurrency || !currencyInfo?.symbol ? '' : currencyInfo?.symbol;
};
